import React from 'react';

import { useTranslation } from 'react-i18next';
import { useHistory, useParams } from 'react-router-dom';

import { routes } from 'lane-shared/config';

import { Button } from 'components/general';

import { ProductsServicesTable } from '../products/ProductsServicesTable';

import styles from '../styles.scss';

type Props = {
  formRoute?: string;
  canManage?: boolean;
};

export function ProductsServicesTab({ formRoute, canManage }: Props) {
  const { t } = useTranslation();
  const { id }: { id: string } = useParams();
  const history = useHistory();

  const handleCreateProduct = () => {
    history.push(
      formRoute ?? routes.channelAdminCreateProductForm.replace(':id', id)
    );
  };

  return (
    <>
      <div className={styles.heading}>
        {canManage && (
          <Button
            testId="newProduct"
            variant="contained"
            onClick={handleCreateProduct}
          >
            {t('abp.productsServices.products.createButton')}
          </Button>
        )}
      </div>
      <ProductsServicesTable canManage={canManage} />
    </>
  );
}
